import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Typography,
  Grid,
  Box,
  IconButton,
  CircularProgress,
  Dialog,
  Button,
  Divider
} from "@mui/material";
import { investorApi, vendorApi } from "../../api/api";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../common/Loader";
import GradientButton from "../common/GradiantButton";
import VendorSubscriptionPlan from "./VendorSubscriptionPlan";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from "react-router-dom";
import { Snackbar } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useDispatch } from "react-redux";
import { updateSubscription } from "../../redux/reducers/userReducer";



const SubscriptionPlans = () => {
  const modalRef = useRef(null);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openPayModal, setOpenPayModal] = useState(false);
  const { user_refferal_code, isKyc } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const userId = useSelector((state) => state.user.userId);
  const theme = useSelector((data) => data.themeValue.colors);
  const navigate = useNavigate();
  const [showKycSnackbar, setShowKycSnackbar] = useState(false);

  const [paymentScreenshot, setPaymentScreenshot] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState(null);

  const location = useLocation();
  const preSelectedPlan = location.state?.selectedPlan || null;

  const [selectedPlan, setSelectedPlan] = useState(preSelectedPlan);
  const [selectedPeriods, setSelectedPeriods] = useState({});

  // const freePlan = {
  //   id: 0,
  //   name: "Free",
  //   description: "Free plan allows you to add up to 2 properties and 1 project.",
  //   property_limit: 2,
  //   project_limit: 1,
  //   prices: {
  //     yearly: 0
  //   },
  //   isFree: true
  // };



  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchPlans = async () => {
      try {
        const response = await investorApi.getSubscriptionPlans();
        const data = response.data;

        // console.log(response)
        // debugger
        // Filter plans to only include yearly period
        const filteredPlans = data.map(plan => {
          const yearlyPrice = plan.prices.yearly || plan.prices.Yearly;
          if (yearlyPrice) {
            return {
              ...plan,
              prices: { yearly: yearlyPrice }
            };
          }
          return plan;
        }).filter(plan => plan.prices.yearly || plan.prices.Yearly);

        setPlans(filteredPlans);

        const initialPeriods = {};
        filteredPlans.forEach((plan) => {
          // Set only yearly period for all plans
          initialPeriods[plan.name] = 'yearly';
        });

        setSelectedPeriods(initialPeriods);
        setPlans([...filteredPlans]);

        setSelectedPlan(preSelectedPlan || 'Silver' );
        setLoading(false);
      } catch (error) {
        console.error("Failed to load subscription plans:", error);
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);
  const handleRazorpayPayment = async (selectamound) => {
    try {

      // 1️⃣ CREATE ORDER
      const orderResponse = await investorApi.createRazorpayOrder({
        amount: selectamound
      });

      const { order_id, amount, currency, key } = orderResponse.data;

      const selectedPlanData = plans.find(p => p.name === selectedPlan);

      if (!selectedPlanData) {
        alert("Invalid plan selected!");
        return;
      }

      const options = {
        key: key,
        amount: amount,
        currency: currency,
        order_id: order_id,
        name: "RealMart",
        description: `Subscription: ${selectedPlan}`,

        handler: async function (razorResponse) {
          const data = {
            userId: userId,
            planId: selectedPlanData?.id,
            period: "yearly",     // backend expects period name
            amount: amount / 100, // convert paise → ₹

            // razorpay_payment_id: razorResponse.razorpay_payment_id,
            // razorpay_order_id: razorResponse.razorpay_order_id,
            // razorpay_signature: razorResponse.razorpay_signature
          };

          try {
            const apiResponse = await investorApi.confirmSubscriptionPayment(data);
            dispatch(updateSubscription({ isSubscribed: true }));
            alert(apiResponse.data.message);

            navigate("/home");
          } catch (err) {
            console.error("Subscription save error:", err);
            alert("Payment success but subscription save failed!");
          }
        },

        prefill: {
          name: "User",
          email: "test@example.com",
          contact: "9999999999",
        },

        theme: {
          color: "#3399cc",
        }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (error) {
      console.error("Order creation failed:", error);
      alert("Failed to start payment!");
    }
  };



  // const handleProceedToDetails = async () => {
  //   if (!selectedPlan) {
  //     alert("Please select a subscription plan.");
  //     return;
  //   }

  //   const selectedPlanData = plans.find((p) => p.name === selectedPlan);
  //   const selectedPeriod = 'yearly'; // Always yearly
  //   const amount = selectedPlanData?.prices.yearly || selectedPlanData?.prices.Yearly;
  //   const planId = selectedPlanData?.id;

  //   // ✅ Navigate to VendorSubscriptionPayment page
  //   navigate("/VendorSubscriptionPayment", {
  //     state: {
  //       userId,
  //       planId,
  //       selectedPlan,
  //       selectedPeriod,
  //       amount,
  //       paymentScreenshot,
  //     },
  //   });
  // };

  if (loading) {
    return <Loader />;
  }



  return (
    <Container maxWidth="lg" sx={{ pt: 6, pb: 8 }}>
      <Typography
        variant="h4"
        align="center"
        fontWeight="bold"
        gutterBottom
        sx={{ color: theme.text }}
      >
        Choose Your Subscription Plan
      </Typography>
      <Typography
        variant="body1"
        align="center"
        color="text.secondary"
        mb={5}
        sx={{ color: theme.text }}
      >
        Select a yearly plan based on your property listing needs.
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {plans.map((planObj) => (
          <VendorSubscriptionPlan
            key={planObj.name}
            theme={theme}
            plan={planObj}
            selected={selectedPlan === planObj.name}
            selectedPeriod={'yearly'} // Always yearly
            onSelect={() => setSelectedPlan(planObj.name)}
            onPeriodChange={() => { }} // No period change needed
            showPeriodSelector={false} // Hide period selector
          />
        ))}
      </Grid>

      <Box sx={{ textAlign: "center", mt: 6 }}>
        <GradientButton
          text={`Subscribe to ${selectedPlan} (Yearly)`}
          sx={{ width: { xs: "70%", md: "25%" } }}
          onClick={() => setOpenPayModal(true)}
        />
      </Box>

      <Dialog
        open={openPayModal}
        onClose={() => setOpenPayModal(false)}
        maxWidth="sm"
        fullWidth
      >
        {/* Header */}
        <Box sx={{
          p: 2,
          borderBottom: "1px solid #e5e5e5",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <Typography variant="h6" fontWeight={700}>
            Subscription Checkout
          </Typography>
          <IconButton
            onClick={() => setOpenPayModal(false)}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Body */}
        <Box sx={{ p: 3 }}>
          <Typography color="text.secondary" mb={2}>
            Please confirm your plan and proceed with secure payment.
          </Typography>

          {/* Plan Card */}
          <Box sx={{
            borderRadius: 2,
            p: 2.5,
            mb: 3,
            bgcolor: "#fafafa",
            border: "1px solid #e0e0e0"
          }}>
            <Typography fontWeight={600} mb={1}>
              Selected Plan
            </Typography>
            <Typography variant="h5" fontWeight={700} color="primary">
              {selectedPlan}
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Box sx={{ mb: 2 }}>
              <Typography fontWeight={600} mb={0.5}>
                Billing Period
              </Typography>
              <Typography color="text.secondary">
                Yearly Subscription
              </Typography>
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography fontWeight={600} mb={0.5}>
                Plan Limits
              </Typography>
              {(() => {
                const selectedPlanData = plans.find(p => p.name === selectedPlan);
                return (
                  <Typography color="text.secondary">
                    {selectedPlanData?.property_limit || 0} Properties • {selectedPlanData?.project_limit || 0} Projects
                  </Typography>
                );
              })()}
            </Box>

            <Divider sx={{ my: 2 }} />

            <Typography fontWeight={600} mb={0.5}>
              Total Amount
            </Typography>
            <Typography variant="h4" fontWeight={800} color="#2e7d32">
              ₹{(() => {
                const selectedPlanData = plans.find(p => p.name === selectedPlan);
                const price = selectedPlanData?.prices?.yearly || selectedPlanData?.prices?.Yearly;
                return price ? parseInt(price).toLocaleString('en-IN') : "0";
              })()}
              <Typography
                component="span"
                variant="body2"
                color="text.secondary"
                sx={{ ml: 1, fontWeight: 400 }}
              >
                /year
              </Typography>
            </Typography>
          </Box>

          {/* Plan Description */}
          {(() => {
            const selectedPlanData = plans.find(p => p.name === selectedPlan);
            if (selectedPlanData?.description) {
              return (
                <Box mb={3}>
                  <Typography fontWeight={600} mb={1.5}>
                    Plan Description
                  </Typography>
                  <Box sx={{
                    p: 2,
                    borderRadius: 1.5,
                    bgcolor: "#f8f9fa",
                    borderLeft: "4px solid #1976d2"
                  }}>
                    <Typography variant="body2" color="text.secondary">
                      {selectedPlanData.description}
                    </Typography>
                  </Box>
                </Box>
              );
            }
            return null;
          })()}

          {/* Payment Method */}
          <Box sx={{
            p: 2.5,
            borderRadius: 2,
            border: "1px solid #e0e0e0",
            bgcolor: "#fff"
          }}>
            <Typography fontWeight={600} mb={2}>
              Payment Method
            </Typography>

            <Box sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              p: 2,
              borderRadius: 1.5,
              border: "1px solid #e0e0e0",
              bgcolor: "#fafafa"
            }}>
              <Box sx={{
                width: 48,
                height: 48,
                bgcolor: "#0a2540",
                borderRadius: 1,
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: "1.2rem"
              }}>
                R
              </Box>

              <Box flex={1}>
                <Typography fontWeight={600} fontSize="1rem">
                  Razorpay
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Secure online payment gateway
                </Typography>
              </Box>

              <Box sx={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                bgcolor: "#4caf50",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                <CheckIcon sx={{ fontSize: 16, color: "#fff" }} />
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Footer */}
        <Box sx={{
          p: 2.5,
          borderTop: "1px solid #e5e5e5",
          display: "flex",
          gap: 2,
          bgcolor: "#fafafa"
        }}>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => setOpenPayModal(false)}
            sx={{
              height: 48,
              borderRadius: 1.5,
              fontWeight: 600
            }}
          >
            Cancel
          </Button>
          <GradientButton
            fullWidth
            text="Proceed to Payment"
            onClick={() => {
              if (isKyc !== "Completed") {
                setShowKycSnackbar(true);
                return;
              }

              const selectedPlanData = plans.find(p => p.name === selectedPlan);
              const amount = selectedPlanData?.prices?.yearly || selectedPlanData?.prices?.Yearly;

              handleRazorpayPayment(amount);
            }}
            sx={{ height: 48, borderRadius: 1.5 }}
          />
        </Box>
      </Dialog>
      <Snackbar
        open={showKycSnackbar}
        autoHideDuration={4000}
        onClose={() => setShowKycSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Center horizontally
        ContentProps={{
          sx: {
            backgroundColor: theme.background,
            color: theme.text,
            width: '400px',
            height: '100px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px',
            fontSize: '16px',
          },
        }}
        message="Please complete your KYC to book the property."
        action={
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => {
              setShowKycSnackbar(false);
              navigate("/KYC");
            }}
            sx={{ marginLeft: 2 }}
          >
            Update KYC
          </Button>
        }
      />


      {/* <Box sx={{ textAlign: "center", mt: 6 }}>
        <GradientButton
          text={`Subscribe to ${selectedPlan} (Yearly)`}
          sx={{
            width: { xs: "70%", md: "25%" }  
          }}
          onClick={handleProceedToDetails}
        />
 
        {showPaymentModal && (
          <div
            className="modalOverlay"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 2000,
            }}
            onClick={(e) => {
              if (modalRef.current && !modalRef.current.contains(e.target)) {
                setShowPaymentModal(false);
              }
            }}
          >
            <div
              ref={modalRef}
              style={{
                backgroundColor: "white",
                padding: "24px",
                borderRadius: "8px",
                width: "90%",
                maxWidth: "400px",
                position: "relative",
              }}
            >
              <IconButton
                onClick={() => {
                  setShowPaymentModal(false);
                  setPaymentScreenshot(null);
                  setPreviewUrl(null);
                }}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  color: "#666",
                }}
              >
                <CloseIcon />
              </IconButton>
 
             
              <Box sx={{ mb: 2 }}>
                <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
                  Subscription Details
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5 }}>
                  <strong>Plan:</strong> {selectedPlan}
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5 }}>
                  <strong>Period:</strong> Yearly
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ color: "green", fontWeight: "bold" }}
                >
                  <strong>Amount:</strong> ₹
                  {
                    plans.find((p) => p.name === selectedPlan)?.prices.yearly ||
                    plans.find((p) => p.name === selectedPlan)?.prices.Yearly
                  }
                </Typography>
              </Box>
 
             
              <div style={{ marginBottom: "16px" }}>
                <label
                  htmlFor="payment-upload"
                  style={{
                    display: "inline-block",
                    padding: "10px 20px",
                    backgroundColor: theme.primary_gradient_start_color,
                    color: "white",
                    borderRadius: "10px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    width:"100%"
                  }}
                >
                  Upload Payment Screenshot
                </label>
                <input
                  id="payment-upload"
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setPaymentScreenshot(file);
                      setPreviewUrl(URL.createObjectURL(file));
                    }
                  }}
                />
              </div>
 
              
              {previewUrl && (
                <div style={{ marginBottom: "16px", textAlign: "center" }}>
                  <img
                    src={previewUrl}
                    alt="Payment Screenshot Preview"
                    style={{
                      width: "100%",
                      maxHeight: "300px",
                      objectFit: "contain",
                      borderRadius: "6px",
                    }}
                  />
                </div>
              )}
 
              
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "12px",
                }}
              >
                <GradientButton
                  text={
                    submitting ? (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 1,
                        }}
                      >
                        <CircularProgress size={20} color="inherit" />
                        Submitting...
                      </Box>
                    ) : (
                      "Submit"
                    )
                  }
                  width="100%"
                  height={45}
                  disabled={submitting}
                  onClick={async () => {
                    if (!paymentScreenshot) {
                      alert(
                        "Please upload a payment screenshot before submitting."
                      );
                      return;
                    }
 
                    setSubmitting(true);
                    setMessage(null);
 
                    try {
                      const selectedPlanData = plans.find(
                        (p) => p.name === selectedPlan
                      );
                      const selectedPeriod = 'yearly';
                      const amount = selectedPlanData?.prices.yearly || selectedPlanData?.prices.Yearly;
                      const planId = selectedPlanData?.id;
 
                      const fd = new FormData();
                      fd.append("userId", userId);
                      fd.append("planId", planId);
                      fd.append("period", selectedPeriod);
                      fd.append("amount", amount);
                      fd.append("screenshot", paymentScreenshot);
 
                      const response =
                        await investorApi.confirmSubscriptionPayment(fd);
                      console.log(response.data);
 
                      if (response?.status === 200) {
                        setMessage({
                          type: "success",
                          text: "Payment submitted successfully! Awaiting admin approval.",
                        });
                        setTimeout(() => {
                          setShowPaymentModal(false);
                          setPaymentScreenshot(null);
                          setPreviewUrl(null);
                          setMessage(null);
                        }, 2000);
                      } else {
                        setMessage({
                          type: "error",
                          text:
                            response?.message ||
                            "Something went wrong. Please try again.",
                        });
                      }
                    } catch (err) {
                      console.error("Error submitting payment:", err);
                      setMessage({
                        type: "error",
                        text:
                          "Failed to submit payment. Please try again later.",
                      });
                    } finally {
                      setSubmitting(false);
                    }
                  }}
                />
              </div>
 
              
              {message && (
                <Typography
                  sx={{
                    mt: 2,
                    textAlign: "center",
                    color: message.type === "success" ? "green" : "red",
                    fontWeight: "bold",
                  }}
                >
                  {message.text}
                </Typography>
              )}
            </div>
          </div>
        )}
      </Box> */}
    </Container>
  );
};

export default SubscriptionPlans;